import React, { Component } from 'react';
import { Modal, Button, message } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import TableC from '../../../basicElement/TableC';
import ExportUtil from '../../../../common/ExportUtil';

class SubjectsVisitsNumber extends Component {
    state = {
        data: [],
        visible: false,
        loading: false,
        evaluateRecordId: '',
    }

    show = (evaluateRecordId) => {
        this.setState({
            visible: true,
            evaluateRecordId,
        });
        this.loadData(evaluateRecordId);
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    exportData = () => {
        const { evaluateRecordId } = this.state;
        const url = API_URL.evaluate.exportVisitGroupingVisitCount;
        ExportUtil.export({ 
            evaluateRecordId,
        }, null, url);
        message.success(`开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出`);
    }

    loadData = (evaluateRecordId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryVisitGroupingVisitCount,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                const { list = [] } = res;
                list.unshift({
                    visitGroupingName: '单病人访视次数统计',
                    planPreFilterAmount: '-',
                    planFilterAmount: '-',
                    planRandomAmount: '-',
                    totalScheduledVisitCases: '-',
                    preFilterVisitCount: '当访视方案数=1，取该方案下“预筛选访视”次数合计；\n当访视方案数≥2，该字段内容值计算要求如下：\n第一步：计算出各个访视方案下“预筛选访视”次数合计*该访视方案的计划预筛数的值；\n第二步：所有访视方案下，对第一步计算结果求和；\n第三步：第二步计算结果/所有访视方案的计划预筛数合计值；',
                    filterVisitCount: '当访视方案数=1，取该方案下“筛选访视”次数合计；\n当访视方案数≥2，该字段内容值计算要求如下：\n第一步：计算出各个访视方案下“筛选访视”次数合计*该访视方案的计划筛选数的值；\n第二步：所有访视方案下，对第一步计算结果求和；\n第三步：第二步计算结果/所有访视方案的计划筛选数合计值；',
                    importVisitCount: '当访视方案数=1，取该方案下“导入访视”次数合计；\n当访视方案数≥2，该字段内容值计算要求如下：\n第一步：计算出各个访视方案下“导入访视”次数合计*该访视方案的“计划（随机）入组数”的值；\n第二步：所有访视方案下，对第一步计算结果求和；\n第三步：第二步计算结果/客户项目参数下“随机病例数；',
                    randomVisitCount: '当访视方案数=1，取该方案下“（随机）入组访视”次数合计；\n当访视方案数≥2，该字段内容值计算要求如下：\n第一步：计算出各个访视方案下“（随机）入组访视”次数合计*该访视方案的“计划（随机）入组数”的值；\n第二步：所有访视方案下，对第一步计算结果求和；\n第三步：第二步计算结果/客户项目参数下“随机病例数；',
                    treatVisitCount: '当访视方案数=1，取该方案下“入组后门诊访视（治疗随访）”+“入组后住院访视（治疗随访）”次数合计；\n当访视方案数≥2，该字段内容值计算要求如下：\n第一步：计算出各个访视方案下（“入组后门诊访视（治疗随访）”+“入组后住院访视（治疗随访）”次数合计）*该访视方案的“计划（随机）入组数”的值；\n第二步：所有访视方案下，对第一步计算结果求和；\n第三步：第二步计算结果/客户项目参数下“随机病例数；',
                    nonMedicineVisitCount: '当访视方案数=1，取该方案下“非用药访视”次数合计；\n当访视方案数≥2，该字段内容值计算要求如下：\n第一步：计算出各个访视方案下“非用药访视”次数合计*该访视方案的“计划（随机）入组数”的值；\n第二步：所有访视方案下，对第一步计算结果求和；\n第三步：第二步计算结果/客户项目参数下“随机病例数；',
                    safeFollowUpCount: '当访视方案数=1，取该方案下“入组后门诊访视（治疗后随访）”+“入组后住院访视（治疗后随访）”次数合计；\n当访视方案数≥2，该字段内容值计算要求如下：\n第一步：计算出各个访视方案下（“入组后门诊访视（治疗后随访）”+“入组后住院访视（治疗后随访）”次数合计）*该访视方案的“计划（随机）入组数”的值；\n第二步：所有访视方案下，对第一步计算结果求和；\n第三步：第二步计算结果/客户项目参数下“随机病例数；',
                    eotVisitCount: '当访视方案数=1，取该方案下“治疗结束访视”次数合计；\n当访视方案数≥2，该字段内容值计算要求如下：\n第一步：计算出各个访视方案下“治疗结束访视”次数合计*该访视方案的“计划（随机）入组数”的值；\n第二步：所有访视方案下，对第一步计算结果求和；\n第三步：第二步计算结果/客户项目参数下“随机病例数；',
                    phoneFollowUpCount: '当访视方案数=1，取该方案下“电话随访访视”次数合计；\n当访视方案数≥2，该字段内容值计算要求如下：\n第一步：计算出各个访视方案下“电话随访访视”次数合计*该访视方案的“计划（随机）入组数”的值；\n第二步：所有访视方案下，对第一步计算结果求和；\n第三步：第二步计算结果/客户项目参数下“随机病例数；',
                    outPlanVisitCount: '当访视方案数=1，取该方案下“计划外访视”次数合计；\n当访视方案数≥2，该字段内容值计算要求如下：\n第一步：计算出各个访视方案下“计划外访视”次数合计*该访视方案的“计划（随机）入组数”的值；\n第二步：所有访视方案下，对第一步计算结果求和；\n第三步：第二步计算结果/客户项目参数下“随机病例数；',
                    feedbackCount: '当访视方案数=1，取该方案下“访视类别名称包含“回输””次数合计；\n当访视方案数≥2，该字段内容值计算要求如下：\n第一步：计算出各个访视方案下“访视类别名称包含“回输””次数合计*该访视方案的“计划（随机）入组数”的值；\n第二步：所有访视方案下，对第一步计算结果求和；\n第三步：第二步计算结果/客户项目参数下“随机病例数；',
                });
                this.setState({
                    data: list.length > 1 ? list : [],
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    setWordWrap = (text) => {
        const arr = (text || "").split("\n");
        return (
            <div>
                {arr.map((el) => (
                    <span>
                        {el}
                        <br />
                    </span>
                ))}
            </div>
        );
    }

    getColumns = () => [{
        title: '访视方案名称',
        dataIndex: 'visitGroupingName',
        key: 'visitGroupingName',
        width: 100,
    }, {
        title: '计划预筛数',
        dataIndex: 'planPreFilterAmount',
        key: 'planPreFilterAmount',
        width: 100,
    }, {
        title: '计划筛选数',
        dataIndex: 'planFilterAmount',
        key: 'planFilterAmount',
        width: 100,
    }, {
        title: '计划（随机）入组数',
        dataIndex: 'planRandomAmount',
        key: 'planRandomAmount',
        width: 100,
    }, {
        title: '总访视次数(不包括计划外)',
        dataIndex: 'totalScheduledVisitCases',
        key: 'totalScheduledVisitCases',
        width: 120,
    }, {
        title: '预筛访视次数',
        dataIndex: 'preFilterVisitCount',
        key: 'preFilterVisitCount',
        width: 180,
        render: (text, record, index) => {
            return index == 0 ? this.setWordWrap(text) : text
        }
    }, {
        title: '筛选访视次数',
        dataIndex: 'filterVisitCount',
        key: 'filterVisitCount',
        width: 180,
        render: (text, record, index) => {
            return index == 0 ? this.setWordWrap(text) : text
        }
    }, {
        title: '导入访视次数',
        dataIndex: 'importVisitCount',
        key: 'importVisitCount',
        width: 180,
        render: (text, record, index) => {
            return index == 0 ? this.setWordWrap(text) : text
        }
    }, {
        title: '随机访视次数',
        dataIndex: 'randomVisitCount',
        key: 'randomVisitCount',
        width: 180,
        render: (text, record, index) => {
            return index == 0 ? this.setWordWrap(text) : text
        }
    }, {
        title: '治疗访视次数',
        dataIndex: 'treatVisitCount',
        key: 'treatVisitCount',
        width: 180,
        render: (text, record, index) => {
            return index == 0 ? this.setWordWrap(text) : text
        }
    }, {
        title: '非用药访视访视次数',
        dataIndex: 'nonMedicineVisitCount',
        key: 'nonMedicineVisitCount',
        width: 180,
        render: (text, record, index) => {
            return index == 0 ? this.setWordWrap(text) : text
        }
    }, {
        title: '安全性随访次数',
        dataIndex: 'safeFollowUpCount',
        key: 'safeFollowUpCount',
        width: 180,
        render: (text, record, index) => {
            return index == 0 ? this.setWordWrap(text) : text
        }
    }, {
        title: 'EOT访视次数',
        dataIndex: 'eotVisitCount',
        key: 'eotVisitCount',
        width: 180,
        render: (text, record, index) => {
            return index == 0 ? this.setWordWrap(text) : text
        }
    }, {
        title: '电话随访次数',
        dataIndex: 'phoneFollowUpCount',
        key: 'phoneFollowUpCount',
        width: 180,
        render: (text, record, index) => {
            return index == 0 ? this.setWordWrap(text) : text
        }
    }, {
        title: '计划外访视次数',
        dataIndex: 'outPlanVisitCount',
        key: 'outPlanVisitCount',
        width: 180,
        render: (text, record, index) => {
            return index == 0 ? this.setWordWrap(text) : text
        }
    }, {
        title: '回输次数',
        dataIndex: 'feedbackCount',
        key: 'feedbackCount',
        width: 180,
        render: (text, record, index) => {
            return index == 0 ? this.setWordWrap(text) : text
        }
    }]

    render() {
        const { visible, loading, data } = this.state;
        return (
            <Modal
                title="各访视方案下受试者访视次数"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1100px"
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button 
                            style={{ marginRight: '5px', marginBottom: '10px' }} 
                            type='primary' 
                            onClick={() => this.exportData()}
                        >导出</Button>
                    </div>
                    <div>
                        <TableC
                            data={data}
                            loading={loading}
                            scrollY={400}
                            columns={this.getColumns()}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default SubjectsVisitsNumber;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/SubjectsVisitsNumber.js